module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I cannot miss the opportunity to express my gratitude to everyone who contributed to the completion and production of this book. I would like to mention Dr Ragheb al-Tamimi, son of Dr Rushdy al-Tamimi, Dr Hiam al-Tamimi, my mother, Hala al-Tamimi Al-Maliki, and Najah Al-Tamimi Al-Jundi, daughters of Mr Zaki, for providing me with valuable information.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Special thanks to my father, lawyer Mr Nazir Sinan, who inspired me to document important historical moments and became my primary source of motivation. I extend my appreciation to Dr Sami Marwan Mubayyid, who encouraged me to complete this book and provided historical scrutiny. My dear friend Wasim Al-Sakhla has also been instrumental in offering valuable and important insights.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I am grateful to the linguistic reviewer, Mr Youssef Hossoun, and to Ms. Lynn Jamran, whose dramatic touch enriched the content.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Special thanks to my beloved son, Nazir Sinan Junior; this book owes much of its presence in the English-speaking world to his diligent and skilled efforts. His participation in the editing process, coupled with the insights he has garnered from his studies in Political Science and History at the University of Concordia in Canada, has enriched the content in ways I couldn’t have imagined.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Special thanks to Mr Ivan Habib for the book cover idea.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Finally, I extend my thanks to my beloved wife, May Al-Chaar, for her continuous support, and to my children, Nazir, Karma, and Zaid Sinan.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0251d4e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0